import React, { useState } from "react";
import {
  Card,
  Select,
  Option,
  CardBody,
  Input,
  Button,
  Typography,
  Textarea,
  Checkbox,

} from "@material-tailwind/react";
import ReCAPTCHA from "react-google-recaptcha";
import Notification from "../components/Notification";
const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    budget: "",
    description: "",
    source: "",
    nda: false
  });

  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const [message, setMessage] = useState("");       // رسالة النجاح
  const [errorMessage, setErrorMessage] = useState("");


  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };
  const handleSelectChange = (value) => {
    setFormData({
      ...formData,
      budget: value,
    });
  };
  const handleRecaptcha = (token) => {
    setRecaptchaToken(token); // حفظ التوكن بعد التحقق
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.budget || !formData.description || !formData.source) {
      setErrorMessage("All fields are required. Please fill out the form before submitting.");
      return;
    }
    if (!recaptchaToken) {
      setErrorMessage("Please verify that you are not a robot!");
      return;
    }

    const response = await fetch("https://codify-tech.com/laravel-backend/public/api/contact", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...formData, recaptcha: recaptchaToken }),
    });


    if (response.ok) {
      setMessage("Your message has been sent successfully! ✅");
      setErrorMessage("");
      setFormData({
        name: "",
        email: "",
        budget: "",
        description: "",
        source: "",
        nda: false,
      });
      setRecaptchaToken(null);

    } else {
      setErrorMessage("Something went wrong, please try again.");
    }

  };

  return (

    <section>
      <Notification message={message} type="success" onClose={() => setMessage("")} />
      <Notification message={errorMessage} type="error" onClose={() => setErrorMessage("")} />
      <div className="relative flex flex-col md:flex-row justify-between items-center h-full px-6 md:px-12">

        <img
          src="/bg-prop-6-right.svg"
          alt="codify"
          className="absolute right-0 top-0 w-1/2 h-auto"
        />
        <div className="relative md:w-1/2 flex flex-col justify-start items-start">
          <h2 className="relative transform translate-x-6 md:translate-x-0 md:translate-y-0 translate-y-10 xl:translate-x-10 xl:translate-y-36 text-2xl md:text-4xl font-poppins font-normal leading-tight">
            <span className="block">Talk to us and</span>
            <span className="block font-bold">get your project moving!</span>
          </h2>
          <div className="translate-x-6 translate-y-16 md:translate-x-0 md:translate-y-10 xl:translate-x-10 xl:translate-y-44 space-y-4 text-gray-700">
            <div className="flex items-start space-x-3">
              <img src="/icons8-check (1).svg" alt="check" className="w-6 h-6" />
              <p className="text-lg">We will respond to you within 24 hours.</p>
            </div>
            <div className="flex items-start space-x-3">
              <img src="/icons8-check (1).svg" alt="check" className="w-6 h-6" />
              <p className="text-lg">
                You'll be talking to product and tech experts <br />(no account managers).
              </p>
            </div>
          </div>
        </div>
        <div className="relative sm:translate-x-6 translate-y-20 md:translate-x-10 md:translate-y-10 xl:translate-y-36 md:w-1/2 flex justify-center">
          <Card className="w-full shadow-2xl max-w-[24rem]">
            <CardBody>
              <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
                <div>
                  <Typography
                    variant="small"
                    color="blue-gray"
                    className="mb-2 font-medium  font-poppins"
                  >
                    Name <span className="text-red-500">*</span>
                  </Typography>
                  <Input
                    size="lg"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="name"
                    className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                    labelProps={{
                      className: "before:content-none after:content-none",
                    }}
                  />
                </div>
                <div>
                  <Typography
                    variant="small"
                    color="blue-gray"
                    className="mb-2 font-medium font-poppins"
                  >
                    Email <span className="text-red-500">*</span>
                  </Typography>
                  <Input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="name@mail.com"
                    className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                    labelProps={{
                      className: "before:content-none after:content-none",
                    }}
                  />
                </div>
                <div>
                  <Typography
                    variant="small"
                    color="blue-gray"
                    className="mb-2 font-medium font-poppins"
                  >
                    Budget Size <span className="text-red-500">*</span>

                  </Typography>
                  <Select
                    value={formData.budget}
                    onChange={handleSelectChange}
                    className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                    labelProps={{
                      className: "before:content-none after:content-none",
                    }}
                  >
                    <Option value="<50k">&lt;50k</Option>
                    <Option value="50k-150k">50k-150k</Option>
                    <Option value="150k-500k">150k-500k</Option>
                    <Option value=">500k">&gt;500k</Option>
                  </Select>
                </div>
                <div>
                  <Typography
                    variant="small"
                    color="blue-gray"
                    className="mb-2 font-medium font-poppins"
                  >
                    Description <span className="text-red-500">*</span>
                  </Typography>
                  <Textarea
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                    labelProps={{
                      className: "before:content-none after:content-none",
                    }}
                  />
                </div>
                <div>
                  <Typography
                    variant="small"
                    color="blue-gray"
                    className="mb-2 font-medium font-poppins"
                  >
                    How did you hear about us? <span className="text-red-500">*</span>
                  </Typography>
                  <Input
                    size="lg"
                    name="source"
                    value={formData.source}
                    onChange={handleChange}
                    className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                    labelProps={{
                      className: "before:content-none after:content-none",
                    }}
                  />
                </div>
                <div>
                  <Checkbox
                    name="nda"
                    checked={formData.nda}
                    onChange={(e) => setFormData({ ...formData, nda: e.target.checked })}
                    className="checked:bg-[#96226E] focus:ring-[#96226E]"
                    label={
                      <span className="font-poppins">
                        This Project requires an NDA
                      </span>

                    }
                  />
                </div>
                <ReCAPTCHA sitekey="6LclVgcrAAAAADYqHsuMak0JbwNcrw-hOM4NcWkr" onChange={handleRecaptcha} />
                <Button
                  type="submit"
                  className="border-2 border-[#96226E] text-[#96226E] font-bold font-poppins rounded-full hover:bg-[#96226E] hover:text-white font-poppins transition duration-300"
                  variant="outlined"
                  size="lg"
                >
                  SUBMIT
                </Button>
              </form>
            </CardBody>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default Contact;
